import React from 'react'
import { useController } from 'react-hook-form'

import Grid from '@mui/material/Grid'
import { Checkbox, FormHelperText, FormLabel, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    formTitle: {
        fontWeight: "bold",
    },
    helperTxt: {
        color: "red"
    }
}));

const Input = ({
    controllerProps,
    margin = 'normal',
    select,
    selectOptions,
    gridProps = {},
    ...props
}) => {
    const { field } = useController({
        defaultValue: '',
        ...controllerProps,
    })
    const classes = useStyles();
 

    return (
        <Grid item xs={12} md={6} {...gridProps} style={{paddingTop:"20px"}}>
            <FormLabel className={classes.formTitle} component="legend">
                <Checkbox color="primary" checked={field.value} {...props} {...field} />
                {props.label}
            </FormLabel>
            {controllerProps.helper && <FormHelperText className={classes.helperTxt}>{<span className={classes.helperTxt} dangerouslySetInnerHTML={{ __html: controllerProps.helper }} />}</FormHelperText>}
        </Grid>
    )
}

export default Input
